export const mathSuggestionsData = [
  "What is the Pythagorean Theorem used for in geometry?",
  "Define independent and dependent events in probability ?",
  "Tell me a fun fact about the math's give me few facts about that",
];
